import styled from 'styled-components';
import { Row, Col } from 'antd';

interface ProgressPartProps {
	percentage: number;
}

export const Content = styled(Col)`
	margin-left: 12px;
`;

export const StyledPercentageDiv = styled.div`
	width: 100% !important;
	background-color: #e0e0e0 !important;
	height: 35px !important;
	border-radius: 10px !important;
	overflow: hidden !important;
	position: relative !important;
	display: flex !important;
`;

const ProgressPart = styled.div<ProgressPartProps>`
	height: 100%;
	position: relative;
	display: flex;
	justify-content: center;
	align-items: center;
	color: #fff;
	width: ${({ percentage }) => percentage}%;

	strong {
		font-size: 1rem;
		font-weight: 600;
	}
`;

export const CategoryOne = styled(ProgressPart)`
	background-color: #2cc852;
`;

export const CategoryTwo = styled(ProgressPart)`
	background-color: #f8d627;
`;

export const CategoryThree = styled(ProgressPart)`
	background-color: #e74150;
`;

export const CategoryFour = styled(ProgressPart)`
	background-color: #9b54e2;
`;

export const StyledDivInformations = styled.div`
	width: 100% !important;
	height: 100% !important;
	border-radius: 10px !important;
	margin-top: 3rem;
`;

export const StyledColHeader = styled(Col)`
	background-color: #f8f8f8 !important;
	border-right: 1px solid #e6e8e8;
	display: flex;
	justify-content: center;
	align-items: center;
	color: black;
	padding: 1rem;

	.ant-typography {
		font-size: 1.1rem;
	}

	:last-child {
		border-right: none;
	}

	&.border-left {
		border-top-left-radius: 10px !important;
	}

	&.border-right {
		border-top-right-radius: 10px !important;
	}
`;

export const StyledLineRow = styled(Row)`
	border-left: 1px solid #e6e8e8;
	border-right: 1px solid #e6e8e8;
	border-bottom: 1px solid #e6e8e8;
	height: 80px;

	:last-child {
		border-bottom-left-radius: 10px !important;
		border-bottom-right-radius: 10px !important;
	}
`;

export const StyledLineCol = styled(Col)`
	height: 100%;
	padding: 1rem;
	border-right: 1px solid #e6e8e8;

	:first-child {
		justify-content: center;
		align-items: center;
		display: flex;
	}

	:last-child {
		border-right: none;
	}
`;

export const CategorySquare = styled.div`
	width: 75px;
	height: 50px;
	border-radius: 6px;
	background-color: ${({ color }) => color};
	justify-content: center;
	align-items: center;
	display: flex;
	span {
		color: #fff;
		font-size: 1rem;
		font-weight: bold;
	}
`;

export const StyledLineRowRisk = styled(Row)`
	border: 2px solid #e6e8e8;
	border-radius: 7px;
	margin-bottom: 0.8rem;
	height: 50px;
`;

export const StyledLineColRisk = styled(Col)`
	background-color: ${({ color }) => color};
	border-right: 1px solid #e6e8e8;
	height: 100%;

	&.border-risk {
		border-bottom-right-radius: 7px;
		border-top-right-radius: 7px;
		border-right: none;
	}

	.task-name {
		margin-top: 0.5rem;
		margin-left: 1rem;
		text-align: left;
	}

	.sequence {
		display: flex;
		align-items: center;
		justify-content: center;
		h3 {
			font-size: 1rem;
			font-weight: bold;
			margin-top: 0.5rem;
		}
	}

	span {
		color: #fff;
		display: flex;
		font-size: 1rem;
		font-weight: bold;
		margin-top: 0.5rem;
		align-items: center;
		justify-content: center;
	}
`;
